import React, { useEffect, useState } from "react";
import { MessageType, Product } from "../constants";
import HealthSendMessage from "./Health/SendMessage";
import TravelSendMessage from "./Travel/SendMessage";
import ServiceSendMessage from "./ServiceBot/SendMessage";
import HomeSendMessage from "./Home/SendMessage";
import TermSendMessage from "./Term/SendMessage";
import TermLifeSendMessage from "./TermLife/SendMessage";
// import InvestmentSendMessage from "./Investment/SendMessage";
import InvestmentSendMessage from "./Investmentv1/SendMessage";
import MotorSendMessage from "./Motor/SendMessage";
import TwoWheelerSendMessage from "./TwoWheeler/SendMessage";
export default function SendMessage({setErrorWebCalling, roomToken, sendMessage, disableInput, uploadFile, GAEvent, productId, isService, agentName, botName ,isOfflineWorkingHour,offWorkingHourMsg, lastMessage,newTermUi, onCallInitialized , webCallIdRef, webCallingEnable, agentMsgReplied, setAgentMsgReplied , totalMsgs}) {
  const [message, setMessage] = useState("");

  // useEffect(() => {
  //   setMessage(message.replace(/[<>""]/gi, ""))
  // }, [message])

  const send = () => {
    if (!message.trim()) {
      return;
    }
    let messagePayload = {}
    if (agentMsgReplied) {
      messagePayload = {
        content: JSON.stringify({
          title: message,
          type: 'MsgReply',
          refMsgContent: agentMsgReplied
        }),
        type: MessageType.json
      }
    } else {
      messagePayload = {
        content: message
      }
    }
    sendMessage(messagePayload);
    setAgentMsgReplied(null);
    setMessage("");
    GAEvent({ eventAction: "NLP-Question", eventlabel: message })
  };
  const sendAfterEnter = (e) => {
    if (e.key == 'Enter') {
      e.preventDefault()
      send();
    }
  };

  const homeButton = () => {
    console.log("hi")
    let option = {
      display_value: "Home",
      key: "home",
      type: "selection"
    }
    let json = {
      content: JSON.stringify(option),
      type: MessageType.json,
    };
    sendMessage(json);


  }

  return (
    <>
      {productId === Product.Health && !isService ?
        <HealthSendMessage
          message={message}
          setMessage={setMessage}
          sendAfterEnter={sendAfterEnter}
          send={send}
          uploadFile={uploadFile}
          homeButton={homeButton}
          agentName = {agentName}
          roomToken = {roomToken}
          setErrorWebCalling={setErrorWebCalling}
          onCallInitialized={onCallInitialized}
          webCallIdRef ={webCallIdRef}
          webCallingEnable={webCallingEnable}
        />
        : null}
      {productId === Product.Travel && !isService ?
        <TravelSendMessage
          message={message}
          setMessage={setMessage}
          sendAfterEnter={sendAfterEnter}
          send={send}
          uploadFile={uploadFile}
        />
        : null}
      {productId === Product.Investment && !isService ?
        <InvestmentSendMessage
          message={message}
          setMessage={setMessage}
          sendAfterEnter={sendAfterEnter}
          send={send}
          uploadFile={uploadFile}
          agentName = {agentName}
          botName={botName}
        />
        : null}
      {isService ?
          <ServiceSendMessage
            message={message}
            setMessage={setMessage}
            sendAfterEnter={sendAfterEnter}
            send={send}
            uploadFile={uploadFile}
            disableInput={disableInput}
            agentName={agentName}
            botName={botName}
            isOfflineWorkingHour={isOfflineWorkingHour}
            offWorkingHourMsg={offWorkingHourMsg}
            lastMessage={lastMessage}
          /> : null}
      {productId === Product.Home && !isService ?
        <HomeSendMessage
          message={message}
          disableInput={disableInput}
          setMessage={setMessage}
          sendAfterEnter={sendAfterEnter}
          send={send}
          uploadFile={uploadFile}
        /> : null
      }
      {productId === Product.Term && !isService && newTermUi?
          <TermLifeSendMessage
          message={message}
          disableInput={disableInput}
          setMessage={setMessage}
          sendAfterEnter={sendAfterEnter}
          send={send}
          uploadFile={uploadFile}
          lastMessage={lastMessage}
          agentName={agentName}
          botName ={botName}
          totalMsgs={totalMsgs}
        /> : null
      }
      {productId === Product.Term && !isService && !newTermUi?
        <TermSendMessage
          message={message}
          disableInput={disableInput}
          setMessage={setMessage}
          sendAfterEnter={sendAfterEnter}
          send={send}
          uploadFile={uploadFile}
          lastMessage={lastMessage}
          agentName={agentName}
        /> : null
      }
      {(productId === Product.Motor || productId === Product.CommercialVehicle) && !isService ?
        <MotorSendMessage
        message={message}
        setMessage={setMessage}
        sendAfterEnter={sendAfterEnter}
        send={send}
        uploadFile={uploadFile}
        disableInput={disableInput}
        agentName={agentName}
        botName={botName}
        isOfflineWorkingHour={isOfflineWorkingHour}
        offWorkingHourMsg={offWorkingHourMsg}
        /> : null
      }
      {productId === Product.Twowheeler && !isService ?
      <TwoWheelerSendMessage
        message={message}
        setMessage={setMessage}
        sendAfterEnter={sendAfterEnter}
        send={send}
        uploadFile={uploadFile}
        agentName={agentName}
        botName={botName}
      />
      : null}
    </>
  );
}
